import React, { useState } from "react";
import styles from "./EditorContainer.module.css";
import { bgColor } from "../../../Global.module.css";
import MenuBar from "../MenuBar/MenuBar";
import EditorBox from "../EditorBox/EditorBox";
import Modal from "../../reusable/Modal/Modal";
import Preview from "../Preview/Preview";

const EditorContainer = () => {
	const [preview, setpreview] = useState(false);

	const showPreview = () => {
		setpreview(!preview);
	};

	return (
		<div className={`${styles.editorContainer} ${bgColor}`}>
			<MenuBar showPreview={showPreview} />
			<div className={styles.mainContainer}>
				<EditorBox />
			</div>
			{preview && (
				<Modal>
					<Preview closePreview={showPreview} />
				</Modal>
			)}
		</div>
	);
};

export default EditorContainer;
